'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _core = require('./core');

var _core2 = _interopRequireDefault(_core);

var _connect = require('./connect');

var _connect2 = _interopRequireDefault(_connect);

var _helpers = require('./helpers');

var helpers = _interopRequireWildcard(_helpers);

require('./expose');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _extends({}, helpers, _core2.default, {
  connect: _connect2.default
});
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL21vZHVsZXMvaW5kZXguanMiXSwibmFtZXMiOlsiaGVscGVycyIsImNvcmUiLCJjb25uZWN0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7OztBQUFBOzs7O0FBQ0E7Ozs7QUFDQTs7SUFBWUEsTzs7QUFDWjs7Ozs7OytCQUdLQSxPLEVBQ0FDLGM7QUFDSEMiLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgY29yZSBmcm9tICcuL2NvcmUnXG5pbXBvcnQgY29ubmVjdCBmcm9tICcuL2Nvbm5lY3QnXG5pbXBvcnQgKiBhcyBoZWxwZXJzIGZyb20gJy4vaGVscGVycydcbmltcG9ydCAnLi9leHBvc2UnXG5cbmV4cG9ydCBkZWZhdWx0IHtcbiAgLi4uaGVscGVycyxcbiAgLi4uY29yZSxcbiAgY29ubmVjdFxufVxuIl19